// Card dei piani (PlanSheet) e tessere di ciò che resta del piano attivo. Le
// righe dei servizi e l'etichetta arrivano dal dettaglio del piano, in italiano;
// qui ci sono le righe calcolate dalle condizioni, tradotte.
export default {
  it: {
    PlanSheet: {
      ilTuoPiano: "Il tuo piano",
      gratis: "Gratis",
      alMese: "/ mese",
      allAnno: "/ anno",
      ogniMesi: "/ {n} mesi",
      mensile: "Mensile",
      annuale: "Annuale",
      ogniMesiFormula: "Ogni {n} mesi",
      formula: "Formula di pagamento",
      visite: "Visite ed esami",
      farmaci: "Farmaci",
      rapido: "Teleconsulto rapido",
      pediatrico: "Teleconsulto pediatrico",
      rapidoEPediatrico: "Teleconsulto rapido e pediatrico",
      specialista: "Teleconsulto con lo specialista",
      prenotazioniIncluseAllAnno: "{n} prenotazioni incluse all'anno, poi {prezzo}",
      prenotazioniIncluse: "prenotazioni incluse",
      aPrenotazione: "{prezzo} a prenotazione",
      unoInclusoAllAnno: "{n} incluso all'anno, poi {prezzo}",
      inclusiAllAnno: "{n} inclusi all'anno, poi {prezzo}",
      incluso: "incluso",
      inclusi: "inclusi",
      prenotazioneInclusa: "prenotazione inclusa",
      prenotazioneA: "prenotazione a {prezzo}",
      notaAsterisco:
        "* Il costo della singola prestazione è a carico del paziente, in aggiunta all'eventuale costo di prenotazione. Il teleconsulto con lo specialista si paga alla tariffa fissata dallo specialista.",
      descrizioneGratuito: "L'accesso alla piattaforma, con i servizi alle tariffe standard.",
      inclusoTessera: "Incluso",
      mostraTutti: "Mostra tutti ({n} in più)",
      mostraMeno: "Mostra meno",
      rimaste: {
        prestazione: "Prenotazioni di visite ed esami rimaste",
        ordine: "Prenotazioni di farmaci rimaste",
        emergenza: "Teleconsulti rapidi rimasti",
        tc_pediatrico: "Teleconsulti pediatrici all'anno",
        teleconsulto: "Prenotazioni di teleconsulto rimaste",
      },
      servizio: {
        prestazione: "Prenotazioni di visite ed esami",
        ordine: "Prenotazioni di farmaci",
        emergenza: "Teleconsulto rapido",
        tc_pediatrico: "Teleconsulto pediatrico",
        teleconsulto: "Teleconsulto con lo specialista",
      },
    },
  },
  en: {
    PlanSheet: {
      ilTuoPiano: "Your plan",
      gratis: "Free",
      alMese: "/ month",
      allAnno: "/ year",
      ogniMesi: "/ {n} months",
      mensile: "Monthly",
      annuale: "Yearly",
      ogniMesiFormula: "Every {n} months",
      formula: "Billing",
      visite: "Visits and tests",
      farmaci: "Medicines",
      rapido: "Rapid teleconsultation",
      pediatrico: "Paediatric teleconsultation",
      rapidoEPediatrico: "Rapid and paediatric teleconsultation",
      specialista: "Teleconsultation with a specialist",
      prenotazioniIncluseAllAnno: "{n} bookings included per year, then {prezzo}",
      prenotazioniIncluse: "bookings included",
      aPrenotazione: "{prezzo} per booking",
      unoInclusoAllAnno: "{n} included per year, then {prezzo}",
      inclusiAllAnno: "{n} included per year, then {prezzo}",
      incluso: "included",
      inclusi: "included",
      prenotazioneInclusa: "booking included",
      prenotazioneA: "booking at {prezzo}",
      notaAsterisco:
        "* The cost of each service is paid by the patient, on top of any booking fee. Teleconsultations with a specialist are charged at the fee set by the specialist.",
      descrizioneGratuito: "Access to the platform, with services at standard fees.",
      inclusoTessera: "Included",
      mostraTutti: "Show all ({n} more)",
      mostraMeno: "Show less",
      rimaste: {
        prestazione: "Visit and test bookings left",
        ordine: "Medicine bookings left",
        emergenza: "Rapid teleconsultations left",
        tc_pediatrico: "Paediatric teleconsultations per year",
        teleconsulto: "Teleconsultation bookings left",
      },
      servizio: {
        prestazione: "Visit and test bookings",
        ordine: "Medicine bookings",
        emergenza: "Rapid teleconsultation",
        tc_pediatrico: "Paediatric teleconsultation",
        teleconsulto: "Teleconsultation with a specialist",
      },
    },
  },
};
